import { OrganizationContactInformation } from "@/types";
import { fieldTypes, SectionHeader, SingleCheckboxFieldProps } from "@ucl/library";
import { FC } from "react";
import { FieldComplexV2 } from "./FieldComplexV2";
import { COMPLEX_FIELD_KEYS } from "@/constants/fieldKeys";
import "./ComplexFields.scss";
import { useAddressApiClient } from "@/hooks/useAddressApiClient";

export interface OrganizationContactInformationComplexValue {
  showHeader?: boolean;
  headerLabel?: string;
}

export interface OrganizationContactInformationComplexFieldProps
  extends fieldTypes.BaseFieldProps<OrganizationContactInformation> {
  complexFieldValue?: OrganizationContactInformationComplexValue;
}

export const OrganizationContactInformationComplexField: FC<
  OrganizationContactInformationComplexFieldProps
> = (props) => {
  const { getAddressesByQuery, getAddressByQuery } = useAddressApiClient();

  return (
    <section className="complex-field-container organization-contact-information">
      <SectionHeader label={props.complexFieldValue?.headerLabel || props.label} hidden={!props.complexFieldValue?.showHeader} />
      <div className="complex-field-content">
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.ORGANIZATION_CONTACT_INFORMATION
              .ORGANIZATION_PHYSICAL_ADDRESS_IS_SAME_AS_HOME_ADDRESS
          }
          complexFieldProps={
            {
              displayAsSwitch: true,
              label: "",
            } as SingleCheckboxFieldProps
          }
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.ORGANIZATION_CONTACT_INFORMATION.ORGANIZATION_PHYSICAL_ADDRESS
          }
          complexFieldProps={
            {
              hidden: !!props.value?.organizationPhysicalAddressIsSameAsHomeAddress,
              getAddressesByQuery,
              getAddressByQuery,
            } as any
          }
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.ORGANIZATION_CONTACT_INFORMATION
              .ORGANIZATION_MAILING_ADDRESS_IS_SAME_AS_ORGANIZATION_PHYSICAL_ADDRESS
          }
          complexFieldProps={
            {
              displayAsSwitch: true,
              label: "",
            } as SingleCheckboxFieldProps
          }
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.ORGANIZATION_CONTACT_INFORMATION.ORGANIZATION_MAILING_ADDRESS
          }
          complexFieldProps={
            {
              hidden: !!props.value?.organizationMailingAddressIsSameAsOrganizationPhysicalAddress,
              getAddressesByQuery,
              getAddressByQuery,
            } as any
          }
        />
      </div>
    </section>
  );
};
